/**
 * Storage size limits for file uploads and sessionStorage
 *
 * MAX_FILE_SIZE: Maximum allowed file size for uploads (10MB)
 * - Prevents users from uploading excessively large files
 * - Applies to image and PDF uploads
 *
 * MAX_STORAGE_SIZE: Maximum allowed size for sessionStorage items (10MB)
 * - Prevents quota exceeded errors in sessionStorage
 * - Applies to base64-encoded images stored in sessionStorage
 */
export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
export const MAX_STORAGE_SIZE = 10 * 1024 * 1024 // 10MB
